import PlusLogoDark from "@/assets/icons/plus-logo-dark.svg";
import PlusLogoLight from "@/assets/icons/plus-logo-light.svg";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Spinner from "@/components/ui/spinner";
import { useContextBarAppearance } from "@/contexts/ContextBarAppearanceContext";
import TodoItem from "@/domain/entities/TodoItem";
import { cn } from "@/lib/utils";
import { t } from "i18next";
import TodoList, { TodoListVariant } from "./TodoList";

type SmartTodosProps = {
    todos: TodoItem[];
    variant?: TodoListVariant;
    isLoading?: boolean;
};

const SmartTodos = ({
    todos,
    variant = TodoListVariant.THREAD,
    isLoading = false,
}: SmartTodosProps) => {
    const { isDeepFocus } = useContextBarAppearance();

    return (
        <Card
            className={cn(
                "flex flex-col",
                variant === TodoListVariant.CUSTOM_VIEW ? "min-h-0" : "flex-1",
                isDeepFocus
                    ? "border border-white/10 bg-white/5 text-white"
                    : "bg-white",
            )}
            variant="white"
        >
            <CardHeader variant="mailInfos">
                <CardTitle
                    className={cn(
                        "flex items-center gap-2",
                        isDeepFocus && "text-white",
                    )}
                >
                    <h2>{t("common.smartToDo")}</h2>
                    <img
                        alt=""
                        className="h-4"
                        src={isDeepFocus ? PlusLogoDark : PlusLogoLight}
                    />{" "}
                </CardTitle>
            </CardHeader>
            <CardContent
                className={cn(
                    variant === TodoListVariant.CUSTOM_VIEW &&
                        "flex min-h-0 flex-1 flex-col",
                )}
                variant="ghost"
            >
                {isLoading && (
                    <div className="flex justify-center py-4">
                        <Spinner size="small" />
                    </div>
                )}
                {!isLoading && todos.length > 0 && (
                    <TodoList todos={todos} variant={variant} />
                )}
                {!isLoading && todos.length === 0 && (
                    <p
                        className={cn(
                            "px-4 text-left text-sm",
                            isDeepFocus && "text-white",
                        )}
                    >
                        {t("widgets.todo.noTodo")}
                    </p>
                )}
            </CardContent>
        </Card>
    );
};

export default SmartTodos;
